import React from 'react'
import styles from './UIGamePlayerInformationUser.module.scss'
import {type PlayerValidator} from '@colonist/game-mechanic-validators'
import {type PlayerColor} from '@colonist/game-states'
import clsx from 'clsx'
import {T, Tooltip} from '@colonist/ui'
import {AnimatedWaitIcon} from '../../../common/AnimatedWaitIcon/index.ts'
import {UIGamePlayerInformationAvatar} from './UIGamePlayerInformationAvatar/index.ts'
// eslint-disable-next-line no-restricted-imports
import {UIImagePathController} from '../../../../../../code/client/shared/scripts/UIEnums.ts'
import IconSpecialBuildPhaseFlag from '@static/images/icon_special_build_phase_flag.svg'
// eslint-disable-next-line no-restricted-imports
import {robberSkinController} from '../../../../../../code/client/shared/scripts/ui_game/UIGameRobberSkinController.ts'

const RushNextRobberIcon = ({playerUsername}: {playerUsername: string}) => {
    const robberImage = robberSkinController.getRobberSkin()
    return <Tooltip
        menuClassName={styles.robberTooltipMenu}
        content={<>
            <T id='strings:game.tips.rushNextRobber.body.0' options={{playerUsername: playerUsername}} />
            <br />
            <br />
            <T id='strings:game.tips.robber.body.0' />
            <br />
            <T id='strings:game.tips.robber.body.1' />
        </>}
        title={<T id='strings:game.tips.rushNextRobber.title' />}
    >
        <img className={styles.iconImage}
            src={robberImage}/>
    </Tooltip>
}

const SpecialBuildPhaseFlagIcon = () =>
    <img className={styles.iconImage}
        src={IconSpecialBuildPhaseFlag}/>

const MerchantIcon = ({color}: {color: PlayerColor}) => <Tooltip
    content={<T id='strings:game.cards.progress.trade.merchant.body' />}
    title={<T id='strings:game.cards.progress.trade.merchant.title' />}
>
    <img className={styles.iconImage} src={UIImagePathController.merchantByColor[color]}/>
</Tooltip>

export interface UIGamePlayerInformationUserProps {
    isTakingAction: boolean
    victoryPointsToWin: number
    playerValidator: PlayerValidator
    isCurrentUser: boolean
    hasMerchant: boolean
    hasSpecialBuildPhaseFlag?: boolean
    hasRobber?: boolean
}

export const UIGamePlayerInformationUser = ({
    isTakingAction,
    victoryPointsToWin,
    playerValidator,
    isCurrentUser,
    hasMerchant,
    hasSpecialBuildPhaseFlag,
    hasRobber,
}: UIGamePlayerInformationUserProps) => (
    <div className={styles.container}>
        <div className={clsx(styles.extraIcons, {
            [styles.currentUser]: isCurrentUser,
        })}>
            {isTakingAction && <AnimatedWaitIcon animationType="fade" className={styles.waitIcon} size={isCurrentUser ? 'large' : 'default'}/>}
            {hasMerchant && <MerchantIcon color={playerValidator.color} />}
            {hasSpecialBuildPhaseFlag && <SpecialBuildPhaseFlagIcon />}
            {hasRobber && <RushNextRobberIcon playerUsername={playerValidator.userState.username} />}
        </div>

        {!isCurrentUser && <div className={styles.username}>{playerValidator.userState.username}</div>}
        <UIGamePlayerInformationAvatar
            isCurrentUser={isCurrentUser}
            playerValidator={playerValidator}
            victoryPointsToWin={victoryPointsToWin}
        />
    </div>
)
